import React from "react";
import { Box, FormControl, InputLabel, Typography } from "@material-ui/core";
import { HelpTooltip } from "../HelpTooltip";

export default function BaseViewWidget(props) {
  var label = props.label,
      help = props.help,
      children = props.children;

  return React.createElement(
    FormControl,
    { fullWidth: true, margin: "none" },
    React.createElement(HelpTooltip, { help: help }),
    React.createElement(
      InputLabel,
      { shrink: true },
      label
    ),
    React.createElement(
      Box,
      { mt: 2 },
      React.createElement(
        Box,
        {
          className: "MuiInputBase-input",
          style: { height: "unset", wordBreak: "break-word" }
        },
        React.createElement(
          Typography,
          { component: "span" },
          children
        )
      )
    )
  );
}